import React from "react";

const Footer = () => {
  return (
    <>
      <div className="footers">
        <footer className="bg-light text-center">
          <p>
            © 2021 RishabhDesigns | All Rights Reserved | Terms and Conditions
          </p>
        </footer>
      </div>
    </>
  );
};

export default Footer;
